module.exports = __webpack_public_path__ + "img/imgaddrbt.dd842a36.png";